var map = {
	"./about_nct.png": 6006,
	"./banner1.jpg": 8741,
	"./banner2.jpg": 9931,
	"./banner3.jpg": 6125,
	"./banner4.jpg": 7572,
	"./certificate-bg.jpg": 7865,
	"./example_avatar.png": 6656,
	"./invalid_bg.png": 6688,
	"./login_bg.png": 4838,
	"./logo-grey.png": 5415,
	"./logo-small.png": 8163,
	"./qrcode_bg.png": 250,
	"./step-icon.png": 9532,
	"./step-icon3.png": 8044,
	"./step1-act.png": 256,
	"./step1.png": 4124,
	"./step2-act.png": 1514,
	"./step2.png": 287,
	"./step3-act.png": 9493,
	"./step3.png": 5051,
	"./step4-act.png": 2291,
	"./step4.png": 8186,
	"./step5-act.png": 6500,
	"./step5.png": 4125,
	"./step6-act.png": 4897,
	"./step6.png": 2696,
	"./swiper_right_btn_bg.png": 3669,
	"./test_content_c_bg.png": 9896,
	"./test_content_python_bg.png": 9998,
	"./test_content_scratch_bg.png": 3204,
	"./test_item_c_bg.png": 5287,
	"./test_item_python_bg.png": 5749,
	"./test_item_scratch_bg.png": 103,
	"./tutorial_step1.png": 1054,
	"./tutorial_step2.png": 8722,
	"./tutorial_step3.png": 7202,
	"./tutorial_step4.png": 9675
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9300;